package com.trevorwiebe.timesheet.calendar.presentation.uiHelper

enum class CalendarType {
    GRID,
    LIST
}